import * as translations from '../../dictionaries/translations';
import _ from 'lodash';

const fallbackLang = 'en';
const languages = {
    en: 'English',
    es: 'Español',
};


//------------------ Find missing translations:
const printMissingTranslations = false;          //TODO: true for testing        <<<<<<<<<<<<<<<<<<<<<<<<<<<
const missingTranslationLanguagesToPrint = [
    'en',
    // 'es'
];
let missingTranslations = {};
//--------------------------------------------


/**
 * returns languages exist for translation
 * @returns {{en: string, es: string}}
 */
export function $getLanguages() {
    return languages;
}

/**
 * Returns language selected, or fallbackLang if not selected
 *
 * PUBLIC
 * @returns {string|string}
 */
export function $getLanguage() {
    return localStorage.getItem('almaLang') ? localStorage.getItem('almaLang') : fallbackLang;
}

/**
 * Sets language received if exists in languages array
 * Returns selected language
 *
 * PUBLIC
 * @param lang: string
 * @returns {*}
 */
export function $setLanguage(lang) {
    if (languages[lang]) {
        localStorage.setItem('almaLang', lang);
    }

    return $getLanguage();
}

/**
 * public translator function
 * receives a path string
 * searches value in translationsNew folder
 * returns value according to selected language
 *
 * PUBLIC
 * @returns {string|null}
 * @param key
 * @param strings - array of strings to replace with '{0}' from translations
 */
export function $t(key, strings = []) {
    if (printMissingTranslations) {
        findMissingTranslations(key);
    }

    let lang = $getLanguage();

    let translation = getTranslation(lang, key, translations.default);

    if (!translation) {
        translation = getTranslation(fallbackLang, key, translations.default);
    }

    if (!translation) {
        let pathArr = (key).split('.');
        translation = pathArr[pathArr.length - 1];
    }

    //Replacing '[[0]]' with strings passed to $f function
    if (strings && Array.isArray(strings)) {
        for (let i = 0; i < strings.length; i++) {
            translation = translation.replace('{0}', strings[i]);
        }
    }

    return translation;
}


function getTranslation(lang, key, translations) {
    let pathArr = key.split('.');
    pathArr.splice(1, 0, lang);

    let translationPointer = translations;
    _.forEach(pathArr, (v, k) => {
        translationPointer = translationPointer[v];

        if (!translationPointer) {
            return false;
        }
    });

    return translationPointer ? translationPointer : null;
}

function findMissingTranslations(originalKey) {
    let key = originalKey.trim()

    let isLastCharAPoint = key.charAt(key.length - 1) === '.';
    key = isLastCharAPoint ? key.slice(0, -1) : key;

    let keysArr = key.split('.')    //array of object nested keys
    let translationKey = keysArr[keysArr.length - 1] + (isLastCharAPoint ? '.' : '');  //missing key

    keysArr.pop();

    _.forEach(missingTranslationLanguagesToPrint, (lang, k) => {
        let res = getTranslation(lang, key, translations.default)

        if (!res) {
            if (!missingTranslations[lang]) {
                missingTranslations[lang] = {};
            }

            let pointer = missingTranslations[lang];
            _.forEach(keysArr, (keyv, keyk) => {
                if (!pointer[keyv]) {
                    pointer[keyv] = {}
                }
                pointer = pointer[keyv];
            })
            pointer[translationKey] = '';

            console.log(`missing [${lang}]: ${key} ${translationKey}`, missingTranslations)
        }
    })
}
